import { render, staticRenderFns } from "./CustomerGroup.vue?vue&type=template&id=12449c0f&scoped=true&lang=pug&"
import script from "./CustomerGroup.vue?vue&type=script&lang=js&"
export * from "./CustomerGroup.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGroup.vue?vue&type=style&index=0&id=12449c0f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12449c0f",
  null
  
)

export default component.exports